import posthog from 'posthog-js';

posthog.init('phc_Q28ok82nscGcYO4uLvi8ZxiHsMen53MpzqikvlVHNDm', {
	api_host: 'https://app.posthog.com',
	person_profiles: 'identified_only',
});

export { posthog };
